import { defineStore } from 'pinia';
import { computed, ref, UnwrapRef } from 'vue';
import { RespUserInfo } from '@vas2t-lowcode/api';
/**
 * 命令相关
 */
export const usePUserStore = defineStore('user', () => {
  /**
   * 页面渲染必须使用的数据是否已经准备好
   */
  const isReady = ref(false);
  /**
   * 用户信息
   */
  const userInfo = ref<RespUserInfo>({});
  /**
   * 跳转到login前的页面
   */
  const lastUrl = ref(location.href);

  /**
   * 已经登录
   */
  const isLogin = computed(() => {
    return !!userInfo.value?.userid;
  });

  /**
   * 清空用户状态
   */
  function initState() {
    userInfo.value = {};
    lastUrl.value = location.href;
  }

  /**
   * 设置用户信息
   * @param user - 用户信息
   */
  function setUserInfo(user: UnwrapRef<typeof userInfo>) {
    userInfo.value = user;
  }

  /**
   * 更新用户信息
   * @param user - 用户信息
   */
  function updateUserInfo(user: UnwrapRef<typeof userInfo>) {
    userInfo.value = { ...userInfo.value, ...user };
  }

  /**
   * 清除登录信息
   */
  function removeLoginInfo() {
    userInfo.value = {} as UnwrapRef<typeof userInfo>;
  }

  return {
    isReady,
    userInfo,
    lastUrl,
    isLogin,
    initState,
    setUserInfo,
    updateUserInfo,
    removeLoginInfo,
  };
});
